import { forwardRef } from 'react';
import { MasonryItemContext } from './masonryContext';
import useMasonry from 'hooks/useMasonry';
import { Box } from '@chakra-ui/react';

const MasonryBase = ({ gap, columnProps, columns, children, customDistribution, ...rest }, ref) => {
    const columnsChildren = useMasonry(children, columns, customDistribution);

    return (
        <Box {...rest} style={{ display: 'flex', gap, ...rest.style }} ref={ref}>
            {columnsChildren.map((column, index) => {
                return (
                    <Box
                        key={`Masonry__Column_${index}`}
                        data-masonry-column={index + 1}
                        {...columnProps}
                        style={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                            gap,
                            ...columnProps?.style,
                        }}
                    >
                        {column.map((child, childIndex) => {
                            return (
                                <MasonryItemContext.Provider
                                    value={{ column: index, position: childIndex }}
                                    key={`Masonry__Column_Child_${childIndex}`}
                                >
                                    {child}
                                </MasonryItemContext.Provider>
                            );
                        })}
                    </Box>
                );
            })}
        </Box>
    );
};

export const Masonry = forwardRef(MasonryBase);
